import $ from "jquery";

const chapterAudio = () => {
  const init = () => {
    Content();
  };

  const Content = () => {

    if ($('.mi-Chapter__Container_Row__Col_Footer--Audio').length === 0) return;

    let sliderDragging = false;
    let wasPlaying = false;
    let audio = {}

    // add class to popup chapter button back and cross close
    $(".js-Navigator_Chapter__Btn, .js-ChapterPrev__Btn, .js-ChapterNext__Btn").addClass(
      "js-PopupChapterAudioButton__Close"
    );
    // add class back footer button
    $(".js-PopupButtonChapter__Back, .js-PopupCloseChapter_Btn").addClass(
      "js-PopupChapterAudioButton__Back"
    );


    // chapter button prev, next, cross close
    const buttonToPause = $(".js-PopupChapterAudioButton__Close");
    const buttonToPlay = $(".js-PopupChapterAudioButton__Back");

    const nextButtonChapter = $(".js-ChapterNext__Btn");
    const prevButtonChapter = $(".js-ChapterPrev__Btn");


    $(".js-ChapterAudio__Audio").each(function () {
      const id = $(this).attr('id');
      audio[id] = this

      $(audio[id]).on("loadedmetadata", function () {
        let minutes = Math.floor(audio[id].duration / 60);
        let seconds = Math.floor(audio[id].duration % 60);
        // add max duration to text
        $(`#DurationTime-${id}`).text(minutes + ":" + (seconds < 10 ? "0" : "") + seconds);
      });

      $(audio[id]).on("timeupdate", function () {
        let currentTime = audio[id].currentTime;
        let progress = (audio[id].currentTime / audio[id].duration) * 100;
        let minutes = Math.floor(currentTime / 60);
        let seconds = Math.floor(currentTime % 60);

        // update progress bar and slider
        $(`#ProgressBar-${id}`).css("width", progress + "%");
        $(`#Slider-${id}`).css("left", progress + "%");
        if (!sliderDragging) {
          $(`#Slider-${id}`).css('left', progress + '%');
        }

        // update time text
        $(`#CurrentTime-${id}`).text(minutes + ":" + (seconds < 10 ? "0" : "") + seconds);
      });

      // handle volume button
      $(document).on("click", `#Volume-${id}`, function () {
        if (!audio[id].muted) {
          audio[id].muted = true;
          $(`#Volume__On-${id}`).css("display", "none");
          $(`#Volume__Off-${id}`).css("display", "inline");
        }
        else {
          audio[id].muted = false;
          $(`#Volume__On-${id}`).css("display", "inline");
          $(`#Volume__Off-${id}`).css("display", "none");
        }
      })

      // handle backward button
      $(document).on("click", `#Backward-${id}`, function () {
        audio[id].currentTime -= 10;
      })

      // handle forward button
      $(document).on("click", `#Forward-${id}`, function () {
        audio[id].currentTime += 10;
      })

      // handle speed button
      $(document).on("click", `#Speed-${id}`, function () {
        if ($(`#Speed-${id}`).html() === '1x') {
          $(`#Speed-${id}`).html('1.5x')
          audio[id].playbackRate = 1.5;
        }
        else if ($(`#Speed-${id}`).html() === '1.5x') {
          $(`#Speed-${id}`).html('2x')
          audio[id].playbackRate = 2;
        }
        else if ($(`#Speed-${id}`).html() === '2x') {
          $(`#Speed-${id}`).html('2.5x')
          audio[id].playbackRate = 2.5;
        }
        else if ($(`#Speed-${id}`).html() === '2.5x') {
          $(`#Speed-${id}`).html('3x')
          audio[id].playbackRate = 3;
        }
        else {
          $(`#Speed-${id}`).html('1x')
          audio[id].playbackRate = 1;
        }
      })

      const changeIcon = (state) => {
        if (state === 'play') {
          $(`#SVGPlaying-${id}`).css("display", "none");
          $(`#SVGPaused-${id}`).css("display", "inline");
        }
        else {
          $(`#SVGPlaying-${id}`).css("display", "inline");
          $(`#SVGPaused-${id}`).css("display", "none");
        }
      }

      // handle play button
      $(document).on("click", `#PlayPause-${id}`, function () {
        if (audio[id].paused) {
          audio[id].play();
          changeIcon('play')
        } else {
          audio[id].pause();
          wasPlaying = false
          changeIcon('pause')
        }
      });

      // update the progressbar when click to slide
      $(document).on("click", `#ProgressBarContainer-${id}`, function (e) {
        var containerWidth = $(this).width();
        var clickX = e.pageX - $(this).offset().left;
        var duration = audio[id].duration;
        var targetTime = (clickX / containerWidth) * duration;
        audio[id].currentTime = targetTime;
      });

      // handling drag the slider
      $(`#Slider-${id}`).on("mousedown", function () {
        sliderDragging = true;
      });

      $(document).on("mouseup", function () {
        if (sliderDragging) {
          sliderDragging = false;
        }
      });

      $(`#ProgressBarContainer-${id}`).on("mousemove", function (e) {
        if (sliderDragging) {
          var containerWidth = $(this).width();
          var clickX = e.pageX - $(this).offset().left;
          var progress = (clickX / containerWidth) * 100;
          if (progress >= 0 && progress <= 100) {
            $(`#Slider-${id}`).css('left', progress + '%');
            $(`#ProgressBar-${id}`).css('width', progress + '%');
            audio[id].currentTime = (progress / 100) * audio[id].duration;
          }
        }
      });

      // handle pause when popup appear and click previous button chapter
      buttonToPause.on("click", function () {
        if (!audio[id].paused) {
          wasPlaying = true
          audio[id].pause();
          changeIcon('pause')
        }
      })
      // handle play when popup disapear
      buttonToPlay.on("click", function () {
        if (wasPlaying) {
          audio[id].play();
          changeIcon('play')
        }
      })
    });

    // remove class when click next chapter button
    nextButtonChapter.add(prevButtonChapter).add('.mi-PopupButton__Yes').on("click", function () {
      $(".js-Navigator_Chapter__Btn, .js-ChapterPrev__Btn").removeClass("js-PopupChapterAudioButton__Close");
      $(".js-PopupButtonChapter__Back, .js-PopupCloseChapter_Btn").removeClass("js-PopupChapterAudioButton__Back");
    });
  };

  init();
};
chapterAudio();
